export const hasEmptyMonthlyTicketObservations = (value) => (
  value === null
  || value === undefined
  || (typeof value === 'string' && value.trim() === '')
);

export const formatMonthlyTicketObservations = (value) => (
  hasEmptyMonthlyTicketObservations(value) ? 'Nada' : value
);

export const monthlyTicketObservationsInputValue = (value) => (
  hasEmptyMonthlyTicketObservations(value) ? '' : value
);
